/* eslint-disable  no-underscore-dangle */
import Icon from 'wever-core/dist/components/common/icon';
import Date from 'wever-core/dist/components/common/date';
import Collection from 'wever-core/dist/components/common/collection';
import Pagination from 'wever-core/dist/components/common/pagination';
import ExternalLink from 'wever-core/dist/components/common/external-link';
import Modal from 'wever-core/dist/components/common/modal';
import Media from 'wever-core/dist/components/common/media';
import Captcha from 'wever-core/dist/components/common/captcha';
export var _Icon = Icon;
export var _Date = Date;
export var _Collection = Collection;
export var _Pagination = Pagination;
export var _ExternalLink = ExternalLink;
export var _Modal = Modal;
export var _Media = Media;
export var _Captcha = Captcha;
var DefaultObject = {
  _Icon: _Icon,
  _Date: _Date,
  _Collection: _Collection,
  _Pagination: _Pagination,
  _ExternalLink: _ExternalLink,
  _Media: _Media,
  _Captcha: _Captcha
};
export default DefaultObject;